import MongoDB_addFields from "./mongodb_components/MongoDB_addFields.jsx";
import MongoDB_Aggregations from "./mongodb_components/MongoDB_Aggregations.jsx";
import MongoDB_Certificate from "./mongodb_components/MongoDB_Certificate.jsx";
import MongoDB_Charts from "./mongodb_components/MongoDB_Charts.jsx";
import MongoDB_Collection from "./mongodb_components/MongoDB_Collection.jsx";
import MongoDB_count from "./mongodb_components/MongoDB_count.jsx";
import MongoDB_CreateDB from "./mongodb_components/MongoDB_CreateDB.jsx";
import MongoDB_DataAPI from "./mongodb_components/MongoDB_DataAPI.jsx";
import MongoDB_Delete from "./mongodb_components/MongoDB_Delete.jsx";
import MongoDB_Drivers from "./mongodb_components/MongoDB_Drivers.jsx";
import MongoDB_Exercises from "./mongodb_components/MongoDB_Exercises.jsx";
import MongoDB_Find from "./mongodb_components/MongoDB_Find.jsx";
import MongoDB_GetStarted from "./mongodb_components/MongoDB_GetStarted.jsx";
import MongoDB_group from "./mongodb_components/MongoDB_group.jsx";
import MongoDB_Home from "./mongodb_components/MongoDB_Home.jsx";
import MongoDB_IndexingSearch from "./mongodb_components/MongoDB_IndexingSearch.jsx";
import MongoDB_Insert from "./mongodb_components/MongoDB_Insert.jsx";
import MongoDB_limit from "./mongodb_components/MongoDB_limit.jsx";
import MongoDB_lookup from "./mongodb_components/MongoDB_lookup.jsx";
import MongoDB_lookup_out from "./mongodb_components/MongoDB_lookup_out.jsx";
import MongoDB_match from "./mongodb_components/MongoDB_match.jsx";
import MongoDB_NodeJSDriver from "./mongodb_components/MongoDB_NodeJSDriver.jsx";
import MongoDB_project from "./mongodb_components/MongoDB_project.jsx";
import MongoDB_QueryAPI from "./mongodb_components/MongoDB_QueryAPI.jsx";
import MongoDB_QueryOperators from "./mongodb_components/MongoDB_QueryOperators.jsx";
import MongoDB_sort from "./mongodb_components/MongoDB_sort.jsx";
import MongoDB_StudyPlan from "./mongodb_components/MongoDB_StudyPlan.jsx";
import MongoDB_Syllabus from "./mongodb_components/MongoDB_Syllabus.jsx";
import MongoDB_Update from "./mongodb_components/MongoDB_Update.jsx";
import MongoDB_UpdateOperators from "./mongodb_components/MongoDB_UpdateOperators.jsx";
import MongoDB_Validation from "./mongodb_components/MongoDB_Validation.jsx";

const MongoDBComponentsMap = {
  "<MongoDB_addFields />": MongoDB_addFields,
  "<MongoDB_Aggregations />": MongoDB_Aggregations,
  "<MongoDB_Certificate />": MongoDB_Certificate,
  "<MongoDB_Charts />": MongoDB_Charts,
  "<MongoDB_Collection />": MongoDB_Collection,
  "<MongoDB_count />": MongoDB_count,
  "<MongoDB_CreateDB />": MongoDB_CreateDB,
  "<MongoDB_DataAPI />": MongoDB_DataAPI,
  "<MongoDB_Delete />": MongoDB_Delete,
  "<MongoDB_Drivers />": MongoDB_Drivers,
  "<MongoDB_Exercises />": MongoDB_Exercises,
  "<MongoDB_Find />": MongoDB_Find,
  "<MongoDB_GetStarted />": MongoDB_GetStarted,
  "<MongoDB_group />": MongoDB_group,
  "<MongoDB_Home />": MongoDB_Home,
  "<MongoDB_IndexingSearch />": MongoDB_IndexingSearch,
  "<MongoDB_Insert />": MongoDB_Insert,
  "<MongoDB_limit />": MongoDB_limit,
  "<MongoDB_lookup />": MongoDB_lookup,
  "<MongoDB_lookup_out />": MongoDB_lookup_out,
  "<MongoDB_match />": MongoDB_match,
  "<MongoDB_NodeJSDriver />": MongoDB_NodeJSDriver,
  "<MongoDB_project />": MongoDB_project,
  "<MongoDB_QueryAPI />": MongoDB_QueryAPI,
  "<MongoDB_QueryOperators />": MongoDB_QueryOperators,
  "<MongoDB_sort />": MongoDB_sort,
  "<MongoDB_StudyPlan />": MongoDB_StudyPlan,
  "<MongoDB_Syllabus />": MongoDB_Syllabus,
  "<MongoDB_Update />": MongoDB_Update,
  "<MongoDB_UpdateOperators />": MongoDB_UpdateOperators,
  "<MongoDB_Validation />": MongoDB_Validation,
};

export default MongoDBComponentsMap;
